
<button [disabled]="disabled"
        style="padding: 0"
        (click)="btnClick.emit()">

  <fa-icon style="font-size: {{size}}" [icon]="icon"></fa-icon>

</button>
